import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export const useDeleteBranchProduct = (successCallback?: () => void): UseMutationResult<null, Error, number> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, number>({
        mutationFn: async (productIdx: number) => {
            const response = await axios.delete(
                `${enum_api_uri.put_branch_product_detail.replace(":branch_product_idx", productIdx.toString())}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getBranchProduct"] });
            successCallback?.();
        },
    });
};
